export type OpenNewWindowParams = {
  width?: number;
  height?: number;
};
export function openNewDesktopWindow(
  params?: OpenNewWindowParams
): Window | null {
  const { width = 500, height = 700 } = params || {};

  const dualScreenLeft = window.screenLeft ?? window.screenX;
  const dualScreenTop = window.screenTop ?? window.screenY;

  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;

  const left = dualScreenLeft + (screenWidth - width) / 2;
  const top = dualScreenTop + (screenHeight - height) / 2;

  return window.open(
    '',
    '_blank',
    `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no, width=${width}, height=${height}, top=${top}, left=${left}`
  );
}
